<template>
  <div class="keyPieces">
    <div class="header">
      <a-row style="width:100%;">
        <a-col :sm="24" :md="20" :lg="20" :xl="20">
          <a-row>
            <a-col :sm="24" :md="12" :lg="12" :xl="12">
              <span class="headerContent">企业名称：{{dataObj.company}}</span>
            </a-col>
            <a-col :sm="24" :md="12" :lg="12" :xl="12">
              <span class="headerContent">证书编号：{{dataObj.number}}</span>
            </a-col>
            <a-col :sm="24" :md="24" :lg="24" :xl="24">
              <span class="headerContent">产品名称：{{dataObj.product}}</span>
            </a-col>
          </a-row>
        </a-col>
        <a-col :sm="24" :md="4" :lg="4" :xl="4">
          <router-link
            style="float:right;padding: 18px 20px;"
            :to="{
            path: '/product/keyPartCertificate',
            name:'keyPart-certificate',
            query: {'page': pageNum, 'blurry': blurry} }"
          ><a-icon type="rollback" />返回</router-link>
        </a-col>
      </a-row>
    </div>
    <div class="table">
      <a-table
      :columns="intactColumns"
      :dataSource="tableData"
      :pagination="false"
      :rowKey="r => r.id"
      :loading="loading"
      @expandRowByClick="true">
        <template slot="product" slot-scope="record">
        <p v-if="record.product">{{record.product | spliceChinese}}</p>
      </template>
        <template slot="modelSpecification" slot-scope="record">
          <a-popover placement="topRight">
              <template slot="content">
                    <p style="width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="record.modelSpecification">{{record.modelSpecification}}</p>
              </template>
                  <p class="item-type" v-if="record.modelSpecification">{{record.modelSpecification}}</p>
            </a-popover>
      </template>
        <template slot="expireDate" slot-scope="record">
          <span v-if="record.expireDate">{{record.expireDate | formatDate}}</span>
          <span v-else>-</span>
        </template>
         <!-- 状态 -->
        <template slot="state" slot-scope="record">
          <common-badge :state="record.state" :text="record.state"></common-badge>
        </template>
        <!-- 操作 -->
        <template slot="operation"  slot-scope="record">
          <a-button type="link" @click="showDrawer(record)" style="padding:0;">详情</a-button>
          &nbsp;
          <a-button type="link" v-if="roles.includes('KEYPIECECERTIFICATE_UNTIE')" @click="relieveAction(record)" style="padding:0;">解除</a-button>
        </template>
      </a-table>
    </div>
    <a-drawer
      :width="600"
      placement="right"
      :closable="false"
      @close="closeDrawer"
      :wrapStyle="{'padding':'0'}"
      :visible="drawervisible">
      <template slot="title">
        <span class="user-title">证书详情</span>
      </template>
      <div class="detail-content" style="font-size:12px;">
        <div class="detail-message">
          <p>
            <span class="detail-message-key">证书编号：</span>
            <span class="detail-message-value" v-if="detailObj.number">{{detailObj.number}}</span>
          </p>
          <p>
              <span class="detail-message-key">委托人名称：</span>
              <span class="detail-message-value" v-if="detailObj.entrustName"> {{detailObj.entrustName}}</span>
            </p>
            <p>
              <span class="detail-message-key">生产者（制造商）名称：</span>
              <span class="detail-message-value" v-if="detailObj.manufacturerName">{{detailObj.manufacturerName}}</span>
            </p>
            <p>
              <span class="detail-message-key">生产企业（生产厂家）名称：</span>
              <span class="detail-message-value" v-if="detailObj.factoryName">{{detailObj.factoryName}}</span>
            </p>
            <p>
              <span class="detail-message-key">产品名称：</span>
              <span class="detail-message-value" v-if="detailObj.product">{{detailObj.product}}</span>
            </p>
            <p>
              <span class="detail-message-key">型号/规格：</span>
              <span class="detail-message-value" v-if="detailObj.modelSpecification">{{detailObj.modelSpecification}}</span>
            </p>
            <p>
              <span class="detail-message-key">产品标准和技术要求：</span>
              <span class="detail-message-value" v-if="detailObj.standard">{{detailObj.standard}}</span>
            </p>
            <p>
              <span class="detail-message-key">发证日期：</span>
              <span class="detail-message-value" v-if="detailObj.issueDate">{{detailObj.issueDate | formatDate}}</span>
            </p>
            <p>
              <span class="detail-message-key">有效期：</span>
              <span class="detail-message-value" v-if="detailObj.expireDate">{{detailObj.expireDate | formatDate}}</span>
            </p>
            <p>
              <span class="detail-message-key">首次发证：</span>
              <span class="detail-message-value" v-if="detailObj.originalChangingTime">{{detailObj.originalChangingTime | formatDate}}</span>
            </p>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import {formatDate,dateDiff} from '@/utils/date';
import {getCertificateDetail, deleteCertificateDetail} from '@/api/keyPart';
import { getKeyPieceCertificates} from '@/utils/auth'
export default {
  data() {
    const align = 'center'
    return {
      data:'',
      loading:false,
      intactColumns:[
        {
          title: "整机证书编号",
          dataIndex: "number",
          align
        },
        {
          title: "产品名称",
          scopedSlots: { customRender: 'product' },
          align
        },
        {
          title: "型号/规格",
          scopedSlots: { customRender: 'modelSpecification' },
          align,
          width:200
        },
        {
          title: "状态",
          scopedSlots: { customRender: 'state' },
          align,
          width:100
        },
        {
          title: "有效期",
          scopedSlots: { customRender: 'expireDate' },
          align
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          align,
          width:120
        }
      ],
      tableData: [],
      dataObj:{
        company:'',
        number:'',
        product:'',
      },
      drawervisible:false,
      visible: false,
      confirmLoading: false,
      detailObj:{
      },
      certificateId: '',
      paramsData: Object,
      roles: [],
      pageNum: '',
      blurry: ''
    }
  },
  created() {
    let query = this.$route.query;
    if (query) {
      this.pageNum = query.page;
    }
    if (query.blurry) {
      this.blurry = query.blurry;
    }
  },
  mounted() {
      let userMsg = this.$store.state.user.user;
      this.roles = userMsg.roles;
      let roleId = this.$store.state.user.roles;
      let typeId;
      if (roleId === 'alphaliner') {
        typeId = 1;
      } else if (roleId === 'company') {
        typeId = 2;
      } else if (roleId === 'admin') {
        typeId = 0;
      }
      setTimeout(() => {
        let query = this.$route.query;
        let newDateObj = getKeyPieceCertificates();
        let params = {
          'deptId': userMsg.deptId,
          'type': typeId,
          'number': newDateObj.number,
          'customerId': newDateObj.dept.id
        }
        this.getBaseData(params);
        this.dataObj.company = newDateObj.dept.name;
        this.dataObj.number = newDateObj.number;
        this.dataObj.product = newDateObj.product;
        this.paramsData = params;
      },200)
      
  },
  methods: {
     /**
     * 关闭详情
     */
    closeDrawer(){
      this.drawervisible =false
    },
    /**
     * 打开详情
     */
    showDrawer(args){
      this.drawervisible =true
      this.detailObj = args
    },
    getBaseData(params) {
      getCertificateDetail(params)
      .then(res =>{
        if (res) {
          let certificates = res.certificates;
          this.tableData = res.certificates;
        } else {
            this.$router.push({path:'/product/keyPartCertificate'});
        } 
      })
      .catch(err => {
      })
    },
    relieveAction(record) {
      let that = this;
      that.$confirm({
          title: '确定要解除吗',
          content: '解除后，该整机证书（'+ that.dataObj.number +'）与此关键件不再有关系',
          okText: '确认',
          cancelText: '取消',
          onOk:function () {
            that.resoveAction(record.id);
          },
        })
    },
    resoveAction(id) {
        this.confirmLoading = true;
        let params = {
          'certificateId': id,
          'number' : this.dataObj.number
        }
        setTimeout(() => {
          deleteCertificateDetail(params)
          .then(res => {
            this.visible = false;
            this.confirmLoading = false;
            let params = this.paramsData;
            this.$message.success('解除成功');
            this.getBaseData(params);
          })
        }, 1000);
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy/MM/dd");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    spliceChinese(val) {
      if (val) {
        var reg = /[\u4e00-\u9fa5]/g;
        if (val.match(reg)) {
            return val.match(reg).join('');
          } else {
            return val;
          }
      }
    }
  },
}
</script>
<style lang="less" scoped>
@detail-gray-color:#a2a2a2;
.item-type {
      display: inline-block;
      width: 200px;
      overflow: hidden;/*超出部分隐藏*/
      white-space: nowrap;/*不换行*/
      text-overflow:ellipsis;
      vertical-align: middle;
      cursor: pointer;
    }
  .keyPieces{
    min-height: 100%;
    .header{
      margin-bottom: 24px;
      padding: 16px;
      overflow: hidden;
      background-color: #fff;
      display: flex;
      .headerContent{
        line-height: 30px;
      }
    }
    .table{
      background-color: #fff;
    }
  }
  .detail-content{
    font-size: 14px;
    .detail-message{
      padding-bottom: 20px;
      // border-bottom: 1px solid #ccc;
      p{
        line-height: 28px;
        .detail-message-key{
          color: @detail-gray-color;
        }
      }
    }
    .detail-adjunct{
      border-bottom: 1px solid #ccc;
      h3{
        border-bottom: 1px solid #ccc;
        line-height: 20px;
        padding: 12px 0;
        font-weight: bold;
      }
      .detail-adjunct-content{
        padding: 12px;
        a{
          padding: 0 8px;
          line-height: 28px;
        }
        
      }
    }
    .detail-record{

      h3{
        border-bottom: 1px solid #ccc;
        line-height: 20px;
        padding: 12px 0;
        font-weight: bold;
      }
      .detail-record-content{
        line-height: 28px;
        padding: 14px;
        overflow: hidden;
        border: 1px solid #ccc;
        border-top: 0;
      }
      .detail-record-adjunct{
        overflow: hidden;
      }
      span{
        margin-right: 15px;
      }
      a{
        padding: 0 8px;
        line-height: 28px;
      }
    }
    
  }
</style>